export * from "ce/utils/permissionHelpers";
import { PERMISSION_TYPE as CE_PERMISSION_TYPE } from "ce/utils/permissionHelpers";

export const PERMISSION_TYPE = {
  ...CE_PERMISSION_TYPE,
};
